// Authorization checks during navigation
export default defineNuxtRouteMiddleware((to, from) => {
    const error = useError();

    // Rendering an error page is an entirely separate page load - skip auth checks if this is the case
    if (error.value && error.value.fatal) return;

    if (useAuth().isRouteAccessible(to)) return;

    const userSession = useUserSessionStore();
    const { unauthorizedRedirectTo } = useRuntimeConfig().public.auth;

    if (!userSession.isAuthenticated)
        return navigateTo({ path: unauthorizedRedirectTo, query: { redirect: to.path === '/' ? undefined : to.path } });
    else throw createError({ status: 401, fatal: true });
});
